import { render, staticRenderFns } from "./Orderfilters.vue?vue&type=template&id=558ea798&"
import script from "./Orderfilters.vue?vue&type=script&lang=js&"
export * from "./Orderfilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports